export const css = {
    statusIcon: 'Nk5R0Tss',
    badgeStatusIcon: '_3hv-KbCu',
    statusNotDone: '_3njlzqgJ',
    statusComplete: '_2nZsd-0Q',
    statusInProgress: '_3Wfcqukk',
    ' _key': 'book-widgets/status-icon'
};
export default css;
